// extracted by mini-css-extract-plugin
export default {"container":"DF-z","innerContainer":"EF-z","multipleLines":"FF-z","heading":"GF-z","content":"HF-z","linkColor":"IF-z"};